import React, {FC, ReactNode} from "react";
import {SvgIcon} from "../../../SvgIcon/SvgIcon";
import classNames from "classnames";

type HelpTextProps = {
    msg: ReactNode;
    id: string;
    variant: "error" | "info";
    className?: string;
    hideIcon?: boolean;
}

export const InlineMessage: FC<HelpTextProps> = ({msg, id, variant, className, hideIcon}) => {
    return (
        <div className={classNames( 
            "InlineMessage",
            {"InlineMessage--error": variant === "error"},
            {"InlineMessage--info": variant === "info"},
            className
        )}>
            {!hideIcon &&
                <SvgIcon iconName={variant === "error" ? "exclamation" : "info"} className="InlineMessage__icon" />
            }
            <p id={id}>
                {msg}
            </p>
        </div>
    )
}